import * as React from "react";
import { DropzoneOptions, FileWithPath, useDropzone } from "react-dropzone";
import "./styles.scss";
import { AppTranslations } from "../../../../../components/Utils/translations/AppTranslations";

declare var AppTranslations: AppTranslations;

interface DropzoneAreaProps {
	onImportedFile: (
		file: readonly FileWithPath[] | FileWithPath | undefined,
	) => void;
	options?: DropzoneOptions;
}

export const DropzoneArea: React.FC<DropzoneAreaProps> = ({
	onImportedFile,
	options,
}) => {
	const { acceptedFiles, getRootProps, getInputProps } = useDropzone(options);

	React.useEffect(() => {
		onImportedFile(acceptedFiles);
	}, [acceptedFiles]);

	return (
		<div {...getRootProps({ className: "dropzone" })}>
			<input {...getInputProps()} />
			<p>{AppTranslations.genericWords.dropOrClickHere}</p>
			{acceptedFiles?.map((file) => (
				<p>{file?.name}</p>
			))}
		</div>
	);
};
